import { Box, Typography } from '@mui/material';
import confetti_bg from '../../assets/backgrounds/confetti.png';
import { getLevelFromPoints } from '../../consts/avatarMap';
import Avatar from '../cards/Avatar';

export default function LeaderboardChart({ topPlayers }) {
    const [ first, second, third ] = topPlayers;
    return (
        <Box 
            className='leaderboard-container'
            sx={{ transition: 'background-position 1.5s', background: `var(--light-green) url(${confetti_bg}) no-repeat`, backgroundSize: 'cover', backgroundPosition: 'bottom', '&:hover' : { backgroundPosition: 'top'  }
         }}
            >
            <Box className="leaderboard-bar-container">
                <Typography className='leaderboard-username-text'>{second?.username}</Typography>
                {
                    second &&
                    <Avatar level={ getLevelFromPoints(second?.totalPoints) }
                        alt="Avatar Second Place"
                        className="leaderboard-avatar hopper"
                    />
                }
                <Box className='leaderboard-bar' sx={{height: 150}}>

                    <Box className="leaderboard-bar-text">
                        <Typography variant="h5" align="center">
                        2
                        </Typography>
                        <Typography variant="body2" align="center">
                            { second && `${second?.totalPoints} points`}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Box className="leaderboard-bar-container">
                <Typography className='leaderboard-username-text'>{first?.username}</Typography>
                {
                    first &&
                    <Avatar level={ getLevelFromPoints(first?.totalPoints) }
                        alt="Avatar First Place"
                        className="leaderboard-avatar hopper"
                    />
                }
                <Box className='leaderboard-bar' sx={{height: 200}}>

                    <Box className="leaderboard-bar-text">
                        <Typography variant="h5" align="center">
                        1
                        </Typography>
                        <Typography variant="body2" align="center">
                            { first && `${first?.totalPoints} points`}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Box className="leaderboard-bar-container">
                <Typography className='leaderboard-username-text'>{third?.username}</Typography>
                {
                    third &&
                    <Avatar level={ getLevelFromPoints(third?.totalPoints) }
                        alt="Avater Third Place"
                        className="leaderboard-avatar hopper"
                    />
                }
                <Box className='leaderboard-bar' sx={{height: 120}}>

                    <Box className="leaderboard-bar-text">
                        <Typography variant="h5" align="center">
                        3
                        </Typography>
                        <Typography variant="body2" align="center">
                            { third && `${third?.totalPoints} points`}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

